import { apiRequest } from '@/services/http'
import type { AvailabilityId } from '@/features/profile/types'

/** `bs-talent.job_preferences` — every array is an elId list; see `metadata-client.ts` to resolve labels. */
export interface JobPreferences {
  status: 'not_open' | 'open' | 'actively_looking'
  seniorityLevel: number[]
  desiredRoles: number[]
  skills: number[]
  industries: number[]
  positionTypes: number[]
  companySizes: number[]
  workspaceType: number[]
  desiredSalary?: number
  currency?: number
  desiredCityIds: number[]
  desiredCountries: string[]
}

export type UpdateJobPreferencesInput = Partial<Omit<JobPreferences, 'desiredCountries'>> & {
  desiredCountries?: string[]
}

export function getMyJobPreferences(): Promise<{ preferences: JobPreferences }> {
  return apiRequest('/v1/job-preferences')
}

export function updateMyJobPreferences(
  input: UpdateJobPreferencesInput,
): Promise<{ preferences: JobPreferences }> {
  return apiRequest('/v1/job-preferences', { method: 'PATCH', body: JSON.stringify(input) })
}

/**
 * `job_preferences.status` is the ONE real availability concept — shared here so
 * `AvailabilityCard` (rendered on multiple pages) and the Job Preferences editor both translate
 * against the same map instead of each defining their own and drifting.
 */
export const STATUS_TO_AVAILABILITY: Record<JobPreferences['status'], AvailabilityId> = {
  not_open: 0,
  open: 1,
  actively_looking: 2,
}
export const AVAILABILITY_TO_STATUS: Record<AvailabilityId, JobPreferences['status']> = {
  0: 'not_open',
  1: 'open',
  2: 'actively_looking',
}
